// função que efetua validação do CPF
export function calcDesconto (v1, p1, p2, p3, p4) {
    let tot = 0
    tot = v1

    if (p1.length) {
      for (var x = 0; x < p1.length; x++) {
        if (p1[x] > 0) {
          tot = tot * (100 - p1[x]) / 100
        }
      }
    } else {
      if (p1 > 0) {
        tot = tot * (100 - p1) / 100
      }
      if (p2 > 0) {
        tot = tot * (100 - p2) / 100
      }
      if (p3 > 0) {
        tot = tot * (100 - p3) / 100
      }
      if (p4 > 0) {
        tot = tot * (100 - p4) / 100
      }
    }
    return arr(tot, 2)
  }

export function arr (vlr, decimals, round) {
    let rounded = 0

    if (round) {
      rounded = vlr.toFixed(decimals)
    } else {
      rounded = vlr.toFixed(decimals)
    }
  
    return parseFloat(rounded)
}
  



// WEBPACK FOOTER //
// ./src/shared/numbers.js